import { useState, useEffect } from "react";
import { detectInAppBrowser, tryOpenExternalBrowser, } from "@f2e/shared/browser/in-app-browser";
/**
 * React hook for detecting in-app browsers.
 *
 * @returns Object containing detection results and utility functions
 */
export function useInAppBrowser() {
    const [info, setInfo] = useState(() => ({
        isInAppBrowser: false,
        browserName: null,
        canOpenExternalBrowser: true,
    }));
    useEffect(() => {
        setInfo(detectInAppBrowser());
    }, []);
    return {
        ...info,
        tryOpenExternal: tryOpenExternalBrowser,
    };
}
//# sourceMappingURL=useInAppBrowser.js.map